import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useState} from "react";
import './Optics/Modal/styleModal.css'
import { Snackbar } from '@mui/material';
import CustomSnackbar from './Optics/Components/CustomSnackbar';
import {handleRegister} from './Optics/AuthorizationData/AuthorizationUser'

const RegistrationDialog = ({ open, onClose}) => {

  const { showSnackbar, snackbarOpen, handleCloseSnackbar, snackbarMessage, snackbarClass } = CustomSnackbar();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleRegisterClick = () => {
    handleRegister(username, password, confirmPassword, email, showSnackbar, setUsername, setPassword, setConfirmPassword, setEmail);
  };
  
  const close = async () => {
    onClose();
    setUsername('');
    setPassword('');
    setConfirmPassword('');
    setEmail('');
  }

    return (
    <Dialog open={open} className="modalStyle">
      <DialogContent>
      <label style={{ color: '#dfab01', fontSize: '20px', fontFamily:'unset'}}>Регистрация</label>
      <hr className='horizontalLineModal'/>
      <div>

        <input
         type="text"
          placeholder="логин"
          className='inputDeleteModal'
          value={username}
          onChange={(e) => setUsername(e.target.value)} 
        />
        <br/>
        
        <input
         type="password"
          placeholder="пароль"
          className='inputDeleteModal'
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <br/>
       
        <input
         type="password"
          placeholder="повторите пароль"
          className='inputDeleteModal'
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
        />

        <br/>
        <input
          type="text"
          placeholder="email"
          className='inputDeleteModal'
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button className='buttonIsDeleteModal' onClick={handleRegisterClick} >Зарегистрироваться</button> 
        <hr className='horizontalLineModal'/>
      </div>

      </DialogContent>

      <DialogActions>
        <Button onClick={close} class='buttonIsHideModal'>
          Закрыть
        </Button>
      </DialogActions>

      {/* Snackbar */}
      <Snackbar
          anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
          }}
          open={snackbarOpen}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          message={snackbarMessage}
          ContentProps={{
            style: {
              color: snackbarClass === 'snackbarOk' ? '#ffbb00' : '#ffbb00'
            }
          }}
        />
    </Dialog>
  );
}

export default RegistrationDialog;
